<template>
  <div class="avatar d-flex justify-center align-items-center text-white bg-primary"
       :class="[getSize(size), getClasses(shadow, circular, borderRadius)]"
       style="font-size: 1.25rem;">
    <i :class="icon"></i>
  </div>
</template>

<script>
export default {
  name: "SoftIcon",
  props: {
    icon: {
      type: String,
      required: true, // 예: 'fas fa-user'
    },
    size: {
      type: String,
      default: null,
    },
    shadow: {
      type: String,
      default: null,
    },
    borderRadius: {
      type: String,
      default: null,
    },
    circular: Boolean,
  },
  methods: {
    getSize(size) {
      return size ? `avatar-${size}` : null;
    },
    getClasses(shadow, circular, borderRadius) {
      const shadowValue = shadow
        ? shadow === "regular"
          ? "shadow"
          : `shadow-${shadow}`
        : null;

      const circularValue = circular ? "rounded-circle" : null;
      const borderRadiusValue = borderRadius
        ? `border-radius-${borderRadius}`
        : null;

      return `${shadowValue} ${circularValue} ${borderRadiusValue}`;
    },
  },
};

</script>